const SELECT_SHARED_QUERY = (context, sharedQuery) => {
  context.selectedSharedQueries.push(sharedQuery);
};

const DESELECT_SHARED_QUERY = (context, sharedQuery) => {
  context.selectedSharedQueries.splice(context.selectedSharedQueries.indexOf(sharedQuery), 1);
};

const CHANGE_SHARED_QUERY_ALL_SELECTED = (context) => {
  context.sharedQueriesAllSelected = !context.sharedQueriesAllSelected;
};

export default {
  SELECT_SHARED_QUERY,
  DESELECT_SHARED_QUERY,
  CHANGE_SHARED_QUERY_ALL_SELECTED,
};
